<i class="{{ icon ? icon : 'mdi mdi-domain-off' }} display-3 text-primary-emphasis"></i>
<h2 class="h3 d-flex py-2 text-primary-emphasis">{{ message }}</h2>
@if (subMessage) {
  <p class="text-primary-emphasis">
    {{ subMessage }}
  </p>
}
@if (labelButton) {
  <button class="btn btn-info fw-bold" type="button" (click)="emit()">
    {{ labelButton }}
  </button>
}
